import './App.css';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import NotFound from './Pages/NotFound';
import ZendeskChatBot from './Pages/ZendeskChatBot';
import TableContant from './Pages/TableContant';

function App() {
  const router = createBrowserRouter([
    {
      element: '',
      // errorElement: <NotFound />,
      children: [
        { path: 'notFound', element: <NotFound /> },
        { path: 'chat', element: <ZendeskChatBot /> },
        { path: 'chat/:id/:key', element: <TableContant /> },
      ],
    },
  ]);

  return <RouterProvider router={router} />;
}

export default App;
